export default __webpack_public_path__ + "static/guruji-7840cfeae1b38bd8e9b1acb8f19f0adf.png";